import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.checklist.edit', []).controller('ChecklistEditCtrl', ChecklistEditCtrl)

/** @ngInject */
function ChecklistEditCtrl(
  $state,
  $q,
  $rootScope,
  $stateParams,
  $timeout,
  TranslatorService,
  PostsAdminService,
  SetsService,
  UploadService,
  ChecklistService,
) {
  var vm = this
  vm.model = {}
  vm.id = parseInt($stateParams.id)
  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.isOpen3 = false
  vm.pathImg = ''

  vm.checklistSegmentations = []
  vm.rewards = []
  vm.rewardTypes = []
  vm.chaseScopes = [
    {
      id: 0,
      name: 'Unspecified',
    },
    {
      id: 1,
      name: 'Collectible',
    },
    {
      id: 2,
      name: 'Set',
    },
    {
      id: 3,
      name: 'Channel',
    },
  ]

  vm.challengeTypes = [
    {
      id: 0,
      name: 'Unspecified',
    },
    {
      id: 1,
      name: 'First N',
    },
    {
      id: 2,
      name: 'Completion Rank',
    },
    {
      id: 3,
      name: 'Top N',
    },
    {
      id: 4,
      name: 'Value Rank',
    },
    {
      id: 5,
      name: 'Completion',
    },
    {
      id: 6,
      name: 'Hold Em',
    },
    {
      id: 7,
      name: 'Hold Em Fast',
    },
  ]

  $('#e15').select2('data', [])

  if ($stateParams.id !== '0') {
    ChecklistService.listSegmentation($stateParams.id).then(function (result) {
      vm.checklistSegmentations = generateType(result.results)
    })
  }

  function loadReward() {
    ChecklistService.listReward($stateParams.id).then(function (result) {
      var items = result.results
      for (var i = 0; i < items.length; i++) {
        if (i === 0) {
          items[i].firstRow = true
        }

        if (items.length - 1 === i) {
          items[i].lastRow = true
        }
      }

      vm.rewardTypes = items
    })
  }

  loadReward()

  ChecklistService.listRewardsType().then(function (result) {
    vm.rewards = result.results
  })

  vm.checklistTranslations = []
  function loadTranslations() {
    ChecklistService.listTranslations($stateParams.id).then(function (result) {
      vm.checklistTranslations = result.results
    })
  }

  loadTranslations()

  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen1 = true
    } else if (type === 2) {
      vm.isOpen2 = true
    } else {
      vm.isOpen3 = true
    }
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  // var makeTranslation = function (t, txt, currentTranslations, paramsId, route, isCreate) {
  //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //     if (vm.title === t && vm.description === txt) {
  //       $state.go(route)
  //       return
  //     }
  //   }

  //   TranslatorService.translateProductAllLanguage(t, txt).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               ChecklistService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ChecklistService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 txt: res.txt.results.zh,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               ChecklistService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ChecklistService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 txt: res.txt.results['zh-TW'],
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               ChecklistService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ChecklistService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 txt: res.txt.results.ko,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               ChecklistService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               ChecklistService.updateTranslation(currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 txt: res.txt.results.ja,
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           if (isCreate) {
  //             $state.go($state.current, { id: paramsId }, { reload: true })
  //           } else {
  //             $state.go(route, { parentId: vm.parentId })
  //           }
  //         })
  //         .catch(function (err) {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           ChecklistService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             txt: res.txt.results.zh,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           ChecklistService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             txt: res.txt.results['zh-TW'],
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           ChecklistService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             txt: res.txt.results.ko,
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           ChecklistService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             txt: res.txt.results.ja,
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises)
  //       .then(function () {
  //         if (isCreate) {
  //           $state.go($state.current, { id: paramsId }, { reload: true })
  //         } else {
  //           $state.go(route, { parentId: vm.parentId })
  //         }
  //       })
  //       .catch(function () {
  //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //       })
  //   })
  // }

  vm.convertTimezone = function () {
    if (vm.data1) {
      vm.timezoneDatePublishedNY = moment(vm.data1)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDatePublishedLA = moment(vm.data1)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
    if (vm.data2) {
      vm.timezoneDateExpiredNY = moment(vm.data2)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDateExpiredLA = moment(vm.data2)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
    if (vm.data3) {
      vm.timezoneDateStartNY = moment(vm.data3).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDateStartLA = moment(vm.data3)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
  }

  if (vm.id !== 0) {
    ChecklistService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      vm.title = vm.model.t
      vm.description = vm.model.txt
      if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
        vm.model['ts-p'] = vm.model['ts-p']
          .toString()
          .substring(0, vm.model['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
        vm.timezoneDatePublishedNY = moment(vm.model['ts-p'])
          .tz('America/New_York')
          .format('MM/DD/YYYY HH:mm A')
        vm.timezoneDatePublishedLA = moment(vm.model['ts-p'])
          .tz('America/Los_Angeles')
          .format('MM/DD/YYYY HH:mm A')
      }
      if (vm.model['ts-start'] !== undefined && vm.model['ts-start'] !== 0) {
        vm.model['ts-start'] = vm.model['ts-start']
          .toString()
          .substring(0, vm.model['ts-start'].toString().length - 3)
        vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start']))
        vm.data3 = angular.copy(vm.model['ts-start'])
        vm.timezoneDateStartNY = moment(vm.model['ts-p'])
          .tz('America/New_York')
          .format('MM/DD/YYYY HH:mm A')
        vm.timezoneDateStartLA = moment(vm.model['ts-p'])
          .tz('America/Los_Angeles')
          .format('MM/DD/YYYY HH:mm A')
      }
      if (vm.model['ts-x'] !== undefined && vm.model['ts-x'] !== 0) {
        vm.model['ts-x'] = vm.model['ts-x']
          .toString()
          .substring(0, vm.model['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x']))
        vm.data2 = angular.copy(vm.model['ts-x'])
        vm.timezoneDateExpiredNY = moment(vm.model['ts-p'])
          .tz('America/New_York')
          .format('MM/DD/YYYY HH:mm A')
        vm.timezoneDateExpiredLA = moment(vm.model['ts-p'])
          .tz('America/Los_Angeles')
          .format('MM/DD/YYYY HH:mm A')
      }
    })
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    if (!model.t) {
      swal('Required title', '', 'error')
      return
    }

    if (model.t.length > 254) {
      swal('Limit title 254 characters', '', 'warning')
      return
    }

    if (model.txt.length > 1000) {
      swal('Limit description 1000 characters', '', 'warning')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        vm.data1.setSeconds(0)
        var date = parseInt(new Date(vm.data1).getTime() + '000')
        model['ts-p'] = date
      } else {
        swal('Date Published At is invalid.', '', 'error')
        return
      }
    } else {
      model['ts-p'] = null
    }
    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        vm.data2.setSeconds(0)
        var date = parseInt(new Date(vm.data2).getTime() + '000')
        model['ts-x'] = date
      } else {
        swal('Date Expired At is invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x'] = null
    }
    if (vm.data3 !== undefined && vm.data3 !== '' && vm.data3 !== null) {
      if (isDate(vm.data3)) {
        vm.data3.setSeconds(0)
        var date = parseInt(new Date(vm.data3).getTime() + '000')
        model['ts-start'] = date
      } else {
        swal('Date Start At is invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      ChecklistService.update(model.id, model).then(
        function () {
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   vm.checklistTranslations,
          //   model.id,
          //   'admin.checklist',
          //   false,
          // )
          $state.go('admin.checklist')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 250)
        },
      )
    } else {
      ChecklistService.save(model).then(
        function (result) {
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   vm.checklistTranslations,
          //   result.results.id,
          //   'admin.checklist',
          //   true,
          // )
          $state.go('admin.checklist')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 250)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.checklist')
  }

  vm.uploadImage = function (item) {
    vm.loadImg = true
    UploadService.save('checklists', vm.pathImg, 'img', !item.id ? 0 : item.id).then(
      function (fileName) {
        vm.loadImg = false
        item['img'] = fileName
      },
    )
  }

  vm.addSegmentation = function (isFromModal) {
    if (!vm.segmentationId || !isFromModal) {
      vm.segmentationId = parseInt($('#e15').select2('val'))
    }
    if (!vm.segmentationId) {
      swal('You need select a Segmentation first', '', 'error')
      return
    }
    ChecklistService.addSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        ChecklistService.listSegmentation($stateParams.id).then(function (result) {
          vm.checklistSegmentations = generateType(result.results)

          if (isFromModal) {
            localStorage.removeItem('checklist_segment_id')
          }
        })
      },
      function () {
        if (isFromModal) {
          ChecklistService.listSegmentation($stateParams.id).then(function (result) {
            vm.checklistSegmentations = generateType(result.results)
            localStorage.removeItem('checklist_segment_id')
          })
        } else {
          swal('This user segmentation already exists', '', 'error')
        }
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChecklistService.removeSegmentation($stateParams.id, id).then(function () {
            ChecklistService.listSegmentation($stateParams.id).then(function (result) {
              vm.checklistSegmentations = generateType(result.results)
            })
          })
        } else {
          return
        }
      },
    )
  }

  function generateType(model) {
    for (var i = 0; i < model.length; i++) {
      if (model[i].k === 1) {
        model[i].type = 'Product'
      } else if (model[i].k === 2) {
        model[i].type = 'Bundle'
      } else if (model[i].k === 3) {
        model[i].type = 'Set'
      } else if (model[i].k === 5) {
        model[i].type = 'Promo'
      } else if (model[i].k === 6) {
        model[i].type = 'User'
      } else if (model[i].k === 7) {
        model[i].type = 'A/B Testing'
      } else if (model[i].k === 8) {
        model[i].type = 'And Segment'
      } else if (model[i].k === 9) {
        model[i].type = 'Xor Segment'
      } else if (model[i].k === 10) {
        model[i].type = 'Not Segment'
      } else if (model[i].k === 11) {
        model[i].type = 'Exclude Segment'
      } else if (model[i].k === 13) {
        model[i].type = 'Listing'
      } else if (model[i].k === 14) {
        model[i].type = 'Fyber'
      } else if (model[i].k === 15) {
        model[i].type = 'Coin Wallet'
      } else if (model[i].k === 16) {
        model[i].type = 'Coin Claim'
      } else if (model[i].k === 17) {
        model[i].type = 'Collection Size'
      } else if (model[i].k === 18) {
        model[i].type = 'Collectible Ownership'
      } else if (model[i].k === 19) {
        model[i].type = 'Collection Value'
      } else if (model[i].k === 20) {
        model[i].type = 'Or Segment'
      } else if (model[i].k === 21) {
        model[i].type = 'Region'
      } else if (model[i].k === 22) {
        model[i].type = 'Language'
      } else if (model[i].k === 23) {
        model[i].type = 'Coupon'
      }
    }
    return model
  }

  vm.translate = {}
  vm.pathImgTranslation = ''
  vm.loadTranslation = false
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslate').modal('show')
  }

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t || !vm.translate.txt) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      ChecklistService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      ChecklistService.saveTranslation($stateParams.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    ChecklistService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslate').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChecklistService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslate').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTranslation = function (item) {
    vm.loadTranslation = true
    UploadService.save('checklists', vm.pathImgTranslation, 'image', item.id).then(
      function (fileName) {
        vm.loadTranslation = false
        item.image = fileName
      },
    )
  }

  vm.addReward = function (isFromModal) {
    if (!vm.rewardId) {
      // swal("You need select a Reward first", "", "error");
      return
    }
    ChecklistService.createReward($stateParams.id, {
      'id-cd': parseInt($stateParams.id),
      'id-rew': vm.rewardId,
    }).then(
      function () {
        loadReward()
        if (isFromModal) {
          localStorage.removeItem('checklist_reward_id')
        }
      },
      function () {
        if (isFromModal) {
          loadReward()
          localStorage.removeItem('checklist_reward_id')
        } else {
          swal('This reward already exists', '', 'error')
        }
      },
    )
  }

  vm.deleteReward = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChecklistService.removeReward(id).then(function () {
            loadReward()
          })
        } else {
          return
        }
      },
    )
  }

  vm.arrowUp = function (item) {
    var copy = angular.copy(item)
    copy.n = copy.n - 1
    ChecklistService.updateReward(copy.id, { n: copy.n }).then(function () {
      loadReward()
    })
  }

  vm.arrowDown = function (item) {
    var copy = angular.copy(item)
    copy.n = copy.n + 1
    ChecklistService.updateReward(copy.id, { n: copy.n }).then(function () {
      loadReward()
    })
  }

  vm.editSegmentation = function (id) {
    localStorage.setItem('checklist_segment_id', id)
    $timeout(function () {
      $('#modalSegmentation').modal('show')
    }, 250)
  }

  vm.openModalSegments = function () {
    localStorage.setItem('checklist_segment_id', 0)
    $timeout(function () {
      $('#modalSegmentation').modal('show')
    }, 250)
  }

  $('#modalSegmentation').on('hidden.bs.modal', function () {
    $timeout(function () {
      if (localStorage.getItem('checklist_segment_id')) {
        console.log('checklist_segment_id', localStorage.getItem('checklist_segment_id'))
        vm.segmentationId = parseInt(localStorage.getItem('checklist_segment_id'))
        for (var i = 0; i < vm.checklistSegmentations.length; i++) {
          if (vm.checklistSegmentations[i].id === vm.segmentationId) {
            return
          }
        }
        vm.addSegmentation(true)
      }
    }, 500)
  })

  vm.editReward = function (id) {
    localStorage.setItem('checklist_reward_id', id)
    vm.isEditReward = true
    $timeout(function () {
      $rootScope.$broadcast('modalReward', id)
      $('#modalReward').modal('show')
    }, 250)
  }

  vm.openModalReward = function () {
    localStorage.setItem('checklist_reward_id', 0)
    vm.isEditReward = false
    $timeout(function () {
      $rootScope.$broadcast('modalReward', 0)
      $('#modalReward').modal('show')
    }, 250)
  }

  $('#modalReward').on('hidden.bs.modal', function () {
    if (localStorage.getItem('checklist_reward_id')) {
      ChecklistService.listRewardsType().then(function (result) {
        vm.rewards = result.results
        vm.rewardId = parseInt(localStorage.getItem('checklist_reward_id'))

        if (vm.isEditReward) {
          loadReward()
          localStorage.removeItem('checklist_reward_id')
          vm.isEditReward = false
        } else {
          vm.addReward(true)
          vm.isEditReward = false
        }
      })
    }
  })

  vm.checklistOptions = [
    {
      id: '',
      name: '',
    },
    {
      id: 'clean_slate',
      name: 'Recollect',
    },
    {
      id: 'rank',
      name: 'Rank',
    },
    {
      id: 'first',
      name: 'First',
    },
    {
      id: 'hold',
      name: "Hold 'Em",
    },
  ]

  vm.checklistOption = vm.checklistOptions[0].id
  vm.valRankMin = ''
  vm.valRankMax = ''

  vm.isOpenChecklist1 = false
  vm.openCalendarChecklist1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist1 = true
  }

  vm.isOpenChecklist2 = false
  vm.openCalendarChecklist2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist2 = true
  }

  vm.isOpenChecklist3 = false
  vm.openCalendarChecklist3 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist3 = true
  }

  vm.isOpenChecklist4 = false
  vm.openCalendarChecklist4 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist4 = true
  }

  vm.createChecklist = function () {
    if (!vm.checklistOption) {
      swal('You must select a option', '', 'warninng')
      return
    }

    if (vm.checklistOption === 'clean_slate') {
      var startsAt
      var endsAt
      if (
        vm.dataChecklist2 !== undefined &&
        vm.dataChecklist2 !== '' &&
        vm.dataChecklist2 !== null
      ) {
        if (isDate(vm.dataChecklist2)) {
          startsAt = new Date(vm.dataChecklist2).toISOString()
        } else {
          startsAt = new Date().toISOString()
        }
      } else {
        startsAt = new Date().toISOString()
      }
      if (
        vm.dataChecklist3 !== undefined &&
        vm.dataChecklist3 !== '' &&
        vm.dataChecklist3 !== null
      ) {
        if (isDate(vm.dataChecklist3)) {
          endsAt = new Date(vm.dataChecklist3).toISOString()
        } else {
          endsAt = ''
        }
      } else {
        endsAt = ''
      }

      var setIds = $('#setSelect').select2('val')
      if (!setIds || setIds.length === 0) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var setId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      SetsService.createChecklistCleanSlate(
        setId,
        'sets',
        startsAt,
        endsAt,
        vm.valRankMin,
        vm.valRankMax,
        $stateParams.id,
        '',
        '',
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          $('#setSelect').select2('data', null)
          vm.dataChecklist2 = null
          vm.dataChecklist3 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Clean slate checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'rank') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      var setIds = $('#setSelect').select2('val')
      if (!setIds || setIds.length === 0) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var setId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      SetsService.createChecklistRank(
        setId,
        'sets',
        expiredAt,
        'Top',
        vm.rankMin,
        vm.rankMax,
        bundleID,
        $stateParams.id,
        '',
        '',
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          $('#setSelect').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Rank checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'first') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      var setIds = $('#setSelect').select2('val')
      if (!setIds || setIds.length === 0) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var setId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      SetsService.createChecklistRank(
        setId,
        'sets',
        expiredAt,
        'First',
        vm.rankMin,
        vm.rankMax,
        bundleID,
        $stateParams.id,
        '',
        '',
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          $('#setSelect').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMin = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>First checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'hold') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      var setIds = $('#setSelect').select2('val')
      if (!setIds || setIds.length === 0) {
        swal('You must select a Set', '', 'warninng')
        return
      }

      var setId = 0
      if (setIds.length === 1) {
        setId = parseInt(setIds[0])
      }

      SetsService.createChecklistHold(
        setId,
        'sets',
        expiredAt,
        bundleID,
        $stateParams.id,
        '',
        '',
        setIds,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          $('#setSelect').select2('data', null)
          vm.dataChecklist4 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += "<h3>Hold 'Em checklist created</h3><br />"
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    }
  }

  vm.changeChecklistOption = function () {
    if (vm.checklistOption == 'rank' || (vm.checklistOption == 'hold' && vm.data2)) {
      vm.dataChecklist4 = vm.data2
    }
  }
}
